/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from 'zod/v4'

export const getProjectsProjectidPreferencesWaterCharacteristicsPathProjectIdSchema = z.string()

export const getProjectsProjectidPreferencesWaterCharacteristicsStatus200Schema = z.discriminatedUnion('mode', [
  z.strictObject({
    density: z.number().nullable().describe('Mass density of the fluid under operating conditions, expressed in kilograms per cubic meter (kg/m³).').meta({ examples: [1000] }),
    freezingPoint: z.number().nullable().describe('Temperature at which the fluid begins to freeze, expressed in degrees Celsius (°C).').meta({ examples: [0] }),
    kinematicViscosity: z.number().nullable().describe('Resistance of the fluid to flow under gravity, expressed in square meters per second (m²/s or cSt).').meta({ examples: [0.001] }),
    mode: z.enum(['manual']).describe('Indicates that all thermo physical fluid properties are entered manually by the user.').meta({ examples: ['manual'] }),
    specificHeat: z.number().nullable().describe('Amount of heat energy required to raise the temperature of one kilogram of fluid by one degree Celsius, expressed in joules per kilogram-kelvin (J/kg·K).').meta({ examples: [4180] }),
  }),
  z.strictObject({
    additives: z.string().nullable().describe('Selected fluid additive or mixture type used to determine predefined thermo physical properties.').meta({ examples: ['C2H5OH_ALC'] }),
    defaultDifferentialTemperature: z.number().nullable().describe('Default temperature difference between supply and return fluid temperatures used for system calculations, expressed in Kelvin (K).').meta({ examples: [5] }),
    mode: z.enum(['predefined']).describe('Indicates that fluid properties are derived from predefined additive and temperature data.').meta({ examples: ['predefined'] }),
    supplyTemperature: z.number().nullable().describe('Operating supply temperature of the fluid used to calculate thermo physical properties, expressed in degrees Celsius (°C).').meta({ examples: [20] }),
    weight: z.number().nullish().describe('Concentration of the selected additive within the fluid mixture, expressed as a percentage by weight.').meta({ examples: [30] }),
  }),
])

export const getProjectsProjectidPreferencesWaterCharacteristicsStatus204Schema = z.null().nullable()

export const getProjectsProjectidPreferencesWaterCharacteristicsStatus401Schema = z.string()

export const getProjectsProjectidPreferencesWaterCharacteristicsResponseSchema = z.union([getProjectsProjectidPreferencesWaterCharacteristicsStatus200Schema, getProjectsProjectidPreferencesWaterCharacteristicsStatus204Schema])

export const getProjectsProjectidPreferencesWaterCharacteristicsErrorSchema = getProjectsProjectidPreferencesWaterCharacteristicsStatus401Schema

export const getProjectsProjectidPreferencesWaterCharacteristicsPathSchema = z.object({
  projectId: z.string(),
})
